/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Ios_TitleInputs */



/**
* | output |
* | --- |
* | "Add Archon to your Home Screen" |
*
* @param {Notifications_Ios_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_ios_title = /** @type {((inputs?: Notifications_Ios_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Ios_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez Archon à votre écran d’accueil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añada Archon a su pantalla de inicio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicione o Archon à sua tela inicial")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi Archon alla schermata Home")
	return /** @type {LocalizedString} */ ("Add Archon to your Home Screen")
});